<script>
import { Popup, Icon, Toast } from 'vant'
import wx from 'weixin-js-sdk'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
    name: 'service-popup',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-popup': Popup,
        'van-icon': Icon,
    },

    //--------------------------------------------------
    // component props
    //--------------------------------------------------
    props: {
        popup: Boolean,
        name: String,
        rights: Array,
        tag: String,
        price: String,
        protocol: Object,
        label: String,
	},

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['change-data'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            showPopup: null,
            ifVipInform: null,
        }
    },

    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
    },

    //--------------------------------------------------
    // component watch
    //--------------------------------------------------
    watch: {
        popup(value) {
            this.showPopup = value
        },
    },
    
    //--------------------------------------------------
    // component mounted
    //--------------------------------------------------
    mounted() {
        this.showPopup = this.popup
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onCancelBtnClick() {
            this.$emit('change-data')
            this.showPopup = false
        },
        onConfirmBtnClick() {
            if(!this.ifVipInform) {
              Toast({
                message: '请阅读后勾选 \n《北京冰球协会会员服务协议》',
              })
              return
            }
            this.$emit('change-data', true)
            this.showPopup = false
        },
        goAgreement(){
            wx.miniProgram.navigateTo({
                url: `/pages/game/userAgreement`
            })
        },
    },
}
</script>

<template>
    <!-- component -->
    <div class="checkbox-list-popup">
        <van-popup 
            v-model="showPopup" 
            position="bottom" 
            round
            @click-overlay="onCancelBtnClick"
        >
            <div class="popUp">
                <div class="pop_top">
                  <div class="pop_top_1">
                    <div class="pop_top_text">
                      <span class="main-title">立即开通数据VIP，解锁全部精彩内容</span>
                    </div>
                    <div class="pop_top_close" @click="onCancelBtnClick">
                      <van-icon name="cross" color="#FFF" size="15" />
                    </div>
                  </div>
                  <div class="pop_top_1">
                    <div class="pop_top_text">
                      <p class="text-title"> 数据VIP特权（首年168元/次年68元） </p>
                      <p class="normal-text"><van-icon name="success" color="#3FD57B" size="14" style="margin-right: 12rpx;" /> 查看球员生涯/赛季/联盟/赛事统计排名</p>
                      <p class="normal-text"><van-icon name="success" color="#3FD57B" size="14" style="margin-right: 12rpx;" /> 查看球员全部赛事组别统计排名</p>
                      <p class="normal-text"><van-icon name="success" color="#3FD57B" size="14" style="margin-right: 12rpx;" /> 查看球员全部比赛统计数据 </p> 
                    </div>
                  </div>
                </div>
                <div class="pop_bottom">
                  <div class="pop_bottom_box1">
                    <img src="https://images.snsports.cn/vipInformIcon.png" v-if="!ifVipInform" @click="ifVipInform = true" />
                    <img src="https://images.snsports.cn/vipInformIconOk.png" v-if="ifVipInform" @click="ifVipInform = false" />
                    <span class="s1" @click="ifVipInform = !ifVipInform">开通前请仔细阅读</span>
                    <span class="s2" @click="goAgreement()">《北京冰球协会会员服务协议》</span>
                  </div>
                  <div class="pop_bottom_box2 flex-conter pop_bottom_box2_active">
                    <div class="left flex-conter left_active">
                      <div class="normal-text">{{ tag }}</div>
                      <p><span>¥</span>{{ price }}</p>
                    </div>
                    <div class="rigth right_active" @click="onConfirmBtnClick">立即开通</div>
                  </div>
                </div>
              </div>
        </van-popup>
    </div>
</template>

<style scoped lang="scss">
.flex-conter{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.popUp {
  background-color: #FFF;
  padding-top: 23px;

  .pop_top {
    .pop_top_1 {
      margin: 0 19px 6px 19px;
      display: flex;
      position: relative;

      .pop_top_text {
        padding-right: 26px;

        .p1 {
          color: #000;
          font-size: 16px;
          font-family: PingFangSC-Medium;
          font-weight: 800;
        }

        .p2 {
          font-size: 14px;
          font-weight: 500;
          color: #000;
          font-family: PingFangSC-Regular;
          // margin-left: 7px;
          margin-top: 15px;
          margin-bottom: 7px;
        }

        .p3 {
          font-size: 12px;
          margin-bottom: 8px;
          // padding-left: 31px;
          color: #8E9196;
        }
      }

      .pop_top_close {
        position: absolute;
        width: 24px;
        height: 24px;
        border-radius: 12px;
        background: #000;
        right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .pop_top_2 {
      margin-bottom: 16px;

      .icon_box {
        display: flex;
        margin-left: 20px;
        margin-bottom: 12px;

        .icon_box_img {
          width: 20px;
          height: 20px;
        }

        span {
          color: #DD9838;
          font-size: 12px;
          line-height: 12px;
          margin: 4px 0 4px 12px;
        }
      }
    }
  }

  .pop_middle {
    background-color: #FFFFFF;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    padding: 21px 20px 65px 20px;
    min-height: 250px;

    .p0 {
      color: #8C8C8C;
      font-size: 12px;
    }

    .pop_middle_box {
      margin-top: 12px;
      display: flex;
      padding: 12px 12px 12px 12px;
      border-radius: 6px;
      border: 1px solid #E8E8E8;
    }

    .pop_middle_box_active {
      border: 1px solid #FD5409;
      background: #FEF6F2;
    }

    .pop_middle_box1 {
      justify-content: flex-start;
      margin-top: 2px;

      .pop_middle_box1_top {
        display: flex;

        .p1 {
          color: #191919;
          font-size: 14px;
        }

        .hot {
          margin-left: 8px;
          margin-top: 2.5px;
          background-color: #FD5409;
          color: #FFFFFF;
          font-size: 10px;
          font-weight: lighter;
          text-align: center;
          width: 42px;
          height: 15px;
          border-bottom-left-radius: 15px;
          border-top-right-radius: 15px;
        }
      }

      .p2 {
        margin-top: 2px;
        color: #8C8C8C;
        font-size: 10px;
      }
    }

    .pop_middle_box2 {
      flex: 1;
      justify-content: flex-end;
      display: flex;

      .pop_middle_box2_text {
        text-align: right;

        .s1 {
          margin-right: 4px;
          color: #8C8C8C;
          font-size: 12px;
        }

        .s2 {
          color: #191919;
          font-size: 24px;
          line-height: 24px;
        }

        .p1 {
          color: #8C8C8C;
          font-size: 10px;
          line-height: 14px;
          text-decoration: line-through;
        }
      }

      .pop_middle_box2_text_active {
        .s1 {
          color: #FD5409;
        }

        .s2 {
          color: #FD5409;
        }
      }
    }
  }

  .tab {
    color: #2E5594;
    text-align: center;
    padding: 7px 0 12px 0;
    background-color: #fff;
    font-size: 12px;
  }
  .pop_top_price{
    text-align: center;
    font-size: 14px;
    color: #D54F3F;
    margin-top: 13px;
    margin-bottom: 2px;
  }

  .pop_bottom {
    background-color: #FFFFFF;
    min-height: 120px;
    padding-left: 16px;
    padding-right: 16px;

    .pop_bottom_box1 {
      display: flex;
      align-items: center;
      padding-top: 12px;

      img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
      }

      .s1 {
        color: #333333;
        font-size: 14px;
      }

      .s2 {
        color: #FA6405;
        font-size: 14px;
      }
    }

    .pop_bottom_box2 {
      width: 349px;
      height: 50px;
      margin-top: 10px;
      background: linear-gradient(105deg, #3C3E45, #2F3034 60%, #EAEEF3 60%, #D1D0DC 100%);
      border-bottom-left-radius: 50px;
      border-top-left-radius: 50px;
      border-bottom-right-radius: 50px;
      border-top-right-radius: 50px;
      display: flex;

      .left {
        width: 180px;
        padding: 0 38px 0 20px;
        font-size: 12px;
        color: #B4B4B4;

        p {
          font-size: 24px;
          font-weight: 500;
          background: linear-gradient(to left, #FFD890, #FFF6DF);
          -webkit-background-clip: text;
          color: transparent;

          span {
            color: #191919;
            font-size: 16px;
            margin-right: 6px;
            background: linear-gradient(to left, #FFD890, #FFF6DF);
            -webkit-background-clip: text;
            color: transparent;
          }
        }
      }

      .left_active {
        p {
          background: linear-gradient(to left, #D1D0DC, #EAEEF3);
          -webkit-background-clip: text;
          color: transparent;

          span {
            background: linear-gradient(to left, #D1D0DC, #EAEEF3);
            -webkit-background-clip: text;
            color: transparent;
          }
        }
      }

      .rigth {
        flex: 1;
        text-align: center;
        line-height: 50px;
        font-size: 18px;
        font-weight: 600;
        color: #784808;
      }

      .right_active {
        color: #3C3B39
      }
    }

    .pop_bottom_box2_active {
      background: linear-gradient(105deg, #3C3E45, #2F3034 60%, #FFF6DF 60%, #FFD890 100%);
    }

  }
}
</style>